import React, { useCallback, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import Spinner from "web/components/Spinner";
import Breadcrumb from "web/components/Breadcrumb";
import { Container, TableWrapper } from "../Reports/reportsStyled"
import AddPlusIcon from "web/assets/svg/PtPlusUserAddPlusIcon";
import { Heading, ListingDataWrapper } from "./VendorPricingStyled";
import { Table } from 'reactstrap';
import EditIcon from "web/assets/svg/PtPlusUserEditIcon";
import DeleteIcon from "web/assets/svg/PtPlusUserDeleteIcon";
import { breadcrumbMapArr, headerArr, vendorListHeaderArr } from "./Constants";
import { ptPlusBuyBackMainLocationList, ptPlusBuyBackSubLocationList, ptPlusBuyBackVendorList } from "redux/actions/adminPTPlusBuyBackFee";
import { ptPlusVendorPricingList, ptPlusVendorFeeItemDelete, ptPlusVendorPricingGetFlatFee } from 'redux/actions/adminPTPlusVendorPricing'
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import AlertModal from "web/components/AlertModal";
import AddVendorPricingCustomerForm from "./Forms/addVendorPricingCustomer";
import AddMoreVendorsToCustomer from "./Forms/addMoreVendorsToCustomer"
import VendorPricingEditModal from "./PopUpModals/vendorPricingEditModal"
import Filters from "./Forms/filters";
import { Pagination } from "@material-ui/lab";
import debounce from "lodash.debounce";
import YesNoModal from "web/components/YesNoModal";
import FlatFeeLisitngModal from "./PopUpModals/flatFeeListingModal";

const VendorPricing = ({ isDownloadingPtPlusVendorPricingCSV, downloadPTPlusVendorPricingCSV }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const token = localStorage.getItem("token")
  const adminRoles = useSelector(state => state.admin.adminRoles)
  const loaderVisible = useSelector(state => state.appReducer.loaderVisible);

  const [addMoreSelectedItem, setAddMoreSelectedItem] = useState()
  const [showVendorPricingModal, setShowVendorPricingModal] = useState(false);
  const [showVendorPricingEditModal, setShowVendorPricingEditModal] = useState(false);
  const [showFlatFeeListingModal, setShowFlatFeeListingModal] = useState(false);
  const [vendorFlatFeeListData, setVendorFlatFeeListData] = useState([])

  const [vendorPriceListingData, setVendorPriceListingData] = useState([]);
  const [customerMainLocationList, setCustomerMainLocationList] = useState([])
  const [customerSubLocationList, setCustomerSubLocationList] = useState([])
  const [vendorLocationList, setVendorLocationList] = useState([])
  const [accordionOpenIndex, setAccordionOpenIndex] = useState()
  const setAccordionFunction = index => {
    setAccordionOpenIndex(index)
  }
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [alertType, setAlertType] = useState("");
  const [modalLink, setModalLink] = useState("/");
  const toggleModal = () => setModal(!modal);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [tableSearch, setTableSearch] = useState('')
  const [deleteItemData, setDeleteItemData] = useState()
  const [yesNoModalOpen, setYesNoModalOpen] = useState(false);
  const yesNoToggleModal = () => setYesNoModalOpen(!yesNoModalOpen);
  const [yesNoModalContent, setYesNoModalContent] = useState();

  //filter state handling
  const [isActive, setIsActive] = useState(true)
  const [filter, setFilter] = useState({
    customerIds: [],
    locationIds: [],
    vendorIds: [],
    active: isActive,
    searchBy: tableSearch
  });

  const handleErrorResponse = (response) => {
    if (response.statusCode === 401) {
      history.push('/sign-in');
      window.location.reload(false);
    } else {
      setPageCount(0)
      setModalContent(response?.data?.error?.message || response.message || response || 'Something went wrong, please try again!')
      setModalLink("");
      toggleModal();
    }
  };


  const getCustomerMainLocationList = async () => {
    try {
      let response = await dispatch(ptPlusBuyBackMainLocationList());
      if (response && response?.success && response?.data && response?.data?.mainLocations) {
        const arr = response?.data?.mainLocations?.map(location => ({
          label: location.locationName,
          value: location.locationId,
        }));
        setCustomerMainLocationList(arr);
      } else {
        handleErrorResponse(response)
      }
    } catch (error) {
      handleErrorResponse(error)
    }
  };

  const getVendorLocationList = async () => {
    try {
      let response = await dispatch(ptPlusBuyBackVendorList());
      if (response && response?.vendorList) {
        const arr = response?.vendorList?.map(location => ({
          label: `${location.locationName} - ${location?.city}, ${location?.state}`,
          value: location.locationId,
          city: location.city,
          state: location.state,
          vendorLocationName: location?.locationName,
        }));
        setVendorLocationList(arr);
      } else {
        handleErrorResponse(response)
      }
    } catch (error) {
      handleErrorResponse(error)
    }
  };

  const getVendorPricingListing = async (selectPage, searchText) => {
    try {
      let data = {
        size: 20,
        number: selectPage,
        sort: "DESC",
        searchCriteria: {
          customerIds: filter?.customerIds?.length > 0 ? filter?.customerIds : null,
          locationIds: filter?.locationIds?.length > 0 ? filter?.locationIds : null,
          vendorIds: filter?.vendorIds?.length > 0 ? filter?.vendorIds : null,
          searchBy: searchText || tableSearch || null,
          active: isActive || filter.active
        }
      }
      let response = await dispatch(ptPlusVendorPricingList(data, token));
      if (response?.success) {
        let delPricingListTempList = response?.data?.deliveryPricingList
        setVendorPriceListingData(delPricingListTempList);
        setPageCount(response?.data?.totalPages)
      } else {
        handleErrorResponse(response)
      }
    } catch (error) {
      handleErrorResponse(error)
    }
  };

  useEffect(() => {
    let userRole = localStorage.getItem('accountType')
    let appUserRolesList = ['Both', 'Buyer', 'Seller']
    if (userRole !== 'Admin') {
      if (appUserRolesList.includes(userRole)) history.push('/dashboard')
      else history.push('/sign-in')
      window.location.reload();
    }
    getVendorLocationList()
    getCustomerMainLocationList()
    getVendorPricingListing(0)
    setPage(1)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);


  const getCustomerSubLocationList = async (locationIds) => {
    try {
      const locationIdsArray = Array.isArray(locationIds) ? locationIds : [locationIds].filter(Boolean);
      const data = { locationIds: locationIdsArray };

      let response = await dispatch(ptPlusBuyBackSubLocationList(data));
      if (response && response?.success && response?.data && response?.data?.locDetList) {
        const arr = response?.data?.locDetList?.map(location => ({
          label: `${location.locationName} - ${location?.city}, ${location?.state}`,
          value: location.locationId,
        }));
        setCustomerSubLocationList(arr);
      } else {
        handleErrorResponse(response)
      }
    } catch (error) {
      handleErrorResponse(error)
    }
  };

  const deleteVendorFeeItem = async () => {
    try {
      let data = {
        id: deleteItemData?.buyBackFeeId,
        vendorLocationId: deleteItemData?.vendorLocationId,
        feeId: deleteItemData?.feeItemId
      }
      let response = await dispatch(ptPlusVendorFeeItemDelete(data, token));
      if (response?.success) {
        setDeleteItemData({})
        setModalContent(response?.msg || response?.data?.msg)
        setAlertType("success")
        setModalLink("");
        toggleModal();
      } else {
        handleErrorResponse(response)
      }
    } catch (error) {
      handleErrorResponse(error)
    }
  };

  const handleDebounceBuyBackFeeSearch = useCallback(
    debounce((selectPage, searchtext) => getVendorPricingListing(selectPage, searchtext), 500),
    []
  );

  const handleSearchChange = e => {
    e.preventDefault()
    setTableSearch(e.target.value)
    setPage(1)
    let searchtext = e.target.value
    setVendorPriceListingData([])
    handleDebounceBuyBackFeeSearch(0, searchtext);
  }


  const handlePageChange = (event, value) => {
    setPage(value);
    setVendorPriceListingData([])
    getVendorPricingListing(value - 1, tableSearch)
  };

  const handleExportClick = () => {
    downloadPTPlusVendorPricingCSV(filter, tableSearch, dispatch)
  }

  const palletDetailsString = (data) => {
    let material = data?.material;
    let condition = data?.condition?.length !== 1 ? data?.condition?.join(", ") : data?.condition;
    let moisture = data?.moisture ? `, ${data?.moisture}` : "";
    let size = data?.size ? (data?.size === "Custom" ? `${data?.length}x${data?.width}x${data?.height}` : data?.size) : "";
    let grade = data?.grade ? `, ${data?.grade}` : "";
    let isHeatTreated = data?.heatTreared ? ", HT" : "";
    let palletType = data?.material === "WOOD" ? `, ${data?.palletType}` : "";
    let hardOrSoftWood = data?.newConditionType === "HARDWOOD" ? "(HW)" : (data?.newConditionType === "SOFTWOOD" ? "(SW)" : "");
    let LWH = data?.material !== "WOOD" ? `${data?.length}x${data?.width}x${data?.height}` : "";

    if (data?.material !== "WOOD") {
      return condition ? `${material}, ${LWH} - ${condition}` : `${material}, ${LWH}`;
    } else {
      return `${size}${grade}${moisture}${isHeatTreated}${palletType} - ${condition || ""}${hardOrSoftWood}`;
    }
  }

  const getFlatFeeFunction = async (items, feeDetail) => {
    let data = {
      customerLocationId: items?.customerLocationId,
      equipment: feeDetail?.equipment === 'LTL' ? 'LTL' : 'FTL',
      palletDetails: feeDetail?.palletDetails,
      rateStartDate: feeDetail?.rateStartDate,
      rateExpirationDate: feeDetail?.rateExpirationDate
    }
    let customerFeeApiResponse = await dispatch(ptPlusVendorPricingGetFlatFee(data, token));
    if (customerFeeApiResponse?.success) {
      setShowFlatFeeListingModal(true)
      setVendorFlatFeeListData({
        flatFeeList: customerFeeApiResponse?.data?.flatFeeList,
        otherDetails: data
      })
    } else {
      setVendorFlatFeeListData([])
      setModalContent(customerFeeApiResponse?.data?.error?.message || customerFeeApiResponse?.data?.message || customerFeeApiResponse?.message || 'Something went wrong, please try again in some time.')
      setModalLink("");
      toggleModal();
      return
    }
  }

  return (
    <>
      {(adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('PT_PLUS'))) ?
        <>
          <Container>
            <div className="buybackfee-listing">
              <Breadcrumb
                breadcrumbArr={breadcrumbMapArr}
                selected='Vendor Pricing'
                title=""
              />
              <AddVendorPricingCustomerForm
                customerMainLocationList={customerMainLocationList}
                vendorLocationList={vendorLocationList}
                customerSubLocationList={customerSubLocationList}
                getCustomerSubLocationList={getCustomerSubLocationList}
                refreshData={() => {
                  getVendorPricingListing(0, tableSearch)
                  setPageCount(0)
                  setPage(1)
                }}
              />
              <TableWrapper>
                {(loaderVisible) && <Spinner />}
                <div className="column">
                  <Heading>
                    <h3>Vendor Pricing</h3>
                    <Filters
                      customerMainLocationList={customerMainLocationList}
                      vendorLocationList={vendorLocationList}
                      customerSubLocationList={customerSubLocationList}
                      getCustomerSubLocationList={getCustomerSubLocationList}
                      isActive={isActive}
                      setIsActive={setIsActive}
                      setFilter={setFilter}
                      onFilterChange={filters => setFilter(filters)}
                      handleSearchChange={handleSearchChange}
                      isDownloadingPtPlusVendorPricingCSV={isDownloadingPtPlusVendorPricingCSV}
                      handleExportClick={handleExportClick}
                    />
                  </Heading>
                  <ListingDataWrapper>
                    <Table responsive>
                      <thead>
                        <tr style={{ background: "rgba(243, 243, 243, 1)" }}>
                          {headerArr.map((items, index) => (
                            <th key={`table-header-${index}`} style={{ color: "rgba(0, 85, 134, 1)" }}>
                              {(items.title).toUpperCase()}
                            </th>
                          ))}
                          <th>{/*Placeholder for action column*/}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {vendorPriceListingData && vendorPriceListingData.length > 0 ? (
                          vendorPriceListingData.map((items, index) => (
                            <>
                              <tr key={index} className='user-list-table-styles'>
                                <td className="font-weight-bold">{items?.customerName}</td>
                                <td>{items?.customerLocationName}</td>
                                <td colspan="1">{items?.street}</td>
                                <td colspan="1">{items?.city}</td>
                                <td colspan="1">{items?.state}</td>
                                <td
                                  className='expand-collapse-class'
                                  style={{ display: 'flex', alignItems: "center", justifyContent: "end" }}
                                >
                                  <button
                                    style={{
                                      background: '#005586',
                                      color: 'white',
                                      border: 0,
                                      borderRadius: '5px',
                                      padding: '4px 10px',
                                      marginRight: "20px"
                                    }}
                                    onClick={() => {
                                      setAddMoreSelectedItem(items)
                                      setShowVendorPricingModal(true)
                                    }}
                                  >
                                    <AddPlusIcon />
                                  </button>

                                  {(accordionOpenIndex === index) ?
                                    <h4 onClick={() => {
                                      setAccordionFunction()
                                    }}><i></i></h4>
                                    : <h5 onClick={() => {
                                      setAccordionFunction(index)
                                    }}><i></i></h5>
                                  }
                                </td>
                              </tr>

                              {accordionOpenIndex === index &&
                                <tr>
                                  <td colSpan={headerArr.length + 1} style={{ padding: "0" }}>
                                    <table
                                      style={{
                                        background: "#E4F2FA",
                                        width: "100%"
                                      }}
                                      className="fee-items-table"
                                    >
                                      {/* Heading for collapse section */}
                                      <thead>
                                        <tr className='order-details-wrapper-heading'>
                                          {vendorListHeaderArr.map((data, index) => <td key={index}><h6>{data}</h6></td>)}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {items?.vendors && items?.vendors?.map((vendor, vendorIndex) => (
                                          vendor.feeDetails.map((feeDetail, feeIndex) => {
                                            return (
                                              <tr className='order-details-wrapper' key={vendorIndex}>
                                                <td><p style={{ whiteSpace: 'nowrap' }}>{`${vendor?.vendorLocationName} - ${vendor?.city}, ${vendor?.state}`}</p></td>
                                                <td><p style={{ whiteSpace: 'nowrap' }}>{palletDetailsString(feeDetail?.palletDetails)}</p></td>
                                                <td><p style={{ whiteSpace: 'nowrap' }}>${feeDetail?.vendorFee?.toFixed(2)}</p></td>
                                                <td><p style={{ whiteSpace: 'nowrap' }}>{feeDetail?.equipment || 'NA'}</p></td>
                                                <td><p>{feeDetail?.rateStartDate}</p></td>
                                                <td><p>{feeDetail?.rateExpirationDate}</p></td>
                                                <td><p title={feeDetail?.comment}>{feeDetail?.comment?.length > 20 ? (feeDetail?.comment?.substring(0, 20).concat('...')) : (feeDetail?.comment ? feeDetail?.comment : 'NA')}</p></td>
                                                <td className='expand-collapse-class' style={{ width: '100%', display: 'flex', position: 'relative', gap: "5px" }}>
                                                  <div
                                                    onClick={() => {
                                                      setAddMoreSelectedItem({ id: items?.id, vendorDetails: vendor, feeDetail: feeDetail })
                                                      setShowVendorPricingEditModal(true)
                                                    }}
                                                  ><EditIcon />
                                                  </div>
                                                  <div
                                                    onClick={() => {
                                                      setDeleteItemData({
                                                        buyBackFeeId: items.id,
                                                        feeItemId: feeDetail.feeId,
                                                        vendorLocationId: vendor.vendorLocationId
                                                      })
                                                      setYesNoModalContent('Are you sure you want to delete this item?');
                                                      yesNoToggleModal();
                                                    }}><DeleteIcon />
                                                  </div>
                                                </td>
                                                <td><button className="get-flat-fee-button-class"
                                                  onClick={() => getFlatFeeFunction(items, feeDetail)}>
                                                  View
                                                </button>
                                                </td>
                                              </tr>
                                            )
                                          })
                                        ))}
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              }
                            </>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={headerArr.length + 1} className="text-center">No Data Found</td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                    {(pageCount && vendorPriceListingData && vendorPriceListingData?.length !== 0) ?
                      <Pagination count={pageCount}
                        page={page}
                        onChange={handlePageChange} />
                      : ""}
                  </ListingDataWrapper>
                </div>
              </TableWrapper>
            </div>
          </Container>
          {showVendorPricingModal &&
            <AddMoreVendorsToCustomer
              addMoreSelectedItem={addMoreSelectedItem}
              vendorLocationList={vendorLocationList}
              closeAddModal={(type) => {
                setShowVendorPricingModal(false)
                if (type === 'addSuccess') {
                  getVendorPricingListing(0, tableSearch)
                  setPageCount(0)
                  setPage(1)
                  setAccordionOpenIndex(0)
                }
              }}
            />
          }
          {showVendorPricingEditModal &&
            <VendorPricingEditModal
              addMoreSelectedItem={addMoreSelectedItem}
              vendorLocationList={vendorLocationList}
              closeModal={(type) => {
                setShowVendorPricingEditModal(false)
                if (type === 'addSuccess') {
                  getVendorPricingListing(0, tableSearch)
                  setPageCount(0)
                  setPage(1)
                  setAccordionOpenIndex(0)
                }
              }}
            />
          }
          {showFlatFeeListingModal &&
            <FlatFeeLisitngModal
              flatFeeListData={vendorFlatFeeListData}
              closeModal={() => {
                setVendorFlatFeeListData([])
                setShowFlatFeeListingModal(false)
              }}
            />
          }
          <YesNoModal
            isOpen={yesNoModalOpen}
            toggle={yesNoToggleModal}
            title=""
            onClickHander={(val) => {
              if (val === "no") {
                yesNoToggleModal()
              } else {
                deleteVendorFeeItem()
                yesNoToggleModal()
              }
            }}
            content={yesNoModalContent}
            link="/ptplus-vendor-pricing"
          />
          <AlertModal
            isOpen={modal}
            toggle={toggleModal}
            title={""}
            alertType={alertType}
            content={modalContent}
            link={modalLink}
            className="alert-msg-container"
            InnerClassName="alert-msg"
            callBackAlert={(val) => {
              if (val === "success") {
                getVendorPricingListing(0, tableSearch)
                setPageCount(0)
                setPage(1)
                setAccordionOpenIndex()
              } else {
                toggleModal()
              }
            }}
          />
        </>
        :
        <p>You are not authorized to view this page.</p>
      }
    </>
  )

}

export default VendorPricing
